import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BROWSER_APIS = {
  fetch: function (_fetch) {
    function fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }
    fetch.toString = function () {
      return _fetch.toString();
    };
    return fetch;
  }(function (url, options) {
    return fetch(url, options);
  })
};
// Create a context for the browser APIs
var BrowserAPIContext = /*#__PURE__*/React.createContext(BROWSER_APIS);

// Create a provider component
var BrowserAPIContextProvider = function BrowserAPIContextProvider(_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? BROWSER_APIS : _ref$value;
  return /*#__PURE__*/React.createElement(BrowserAPIContext.Provider, {
    value: _objectSpread(_objectSpread({}, BROWSER_APIS), value)
  }, children);
};
BrowserAPIContextProvider.displayName = 'BrowserAPIContextProvider';

export { BROWSER_APIS, BrowserAPIContext, BrowserAPIContextProvider };
//# sourceMappingURL=BrowserAPI.js.map
